import { SysAuthProviderModule } from '@/system-modules/auth/SysAuthProvider'
import { SysConsoleProviderModule } from '@/system-modules/console/ConsoleProvider'
import { SysLockScreenProviderModule } from '@/system-modules/lock-screen/LockScreenProvider'
import { SysModManagerProviderModule } from '@/system-modules/mod-manager/ModManagerProvider'
import { SysSyncProviderModule } from '@/system-modules/sync/SysSyncProvider'
import { SysShareProviderModule } from '@/system-modules/share/SysShareProvider'

import { SysWinManagerProviderModule } from '@/system-modules/win-manager/WinManagerProvider'
import { SysUpdateProviderModule } from '@/system-modules/update/SysUpdateProvider'
import { SysGroupsProviderModule } from '@/system-modules/groups/SysGroupsProvider'
import { ISystem } from '@/contracts/system/interface/ISystem'
import { ISysAuthModule } from '@/contracts/system-modules/auth/ISysAuthModule'
import { ISysConsoleModule } from '@/contracts/system-modules/console/ISysConsoleModule'
import { ISysLockScreenModule } from '@/contracts/system-modules/lock-screen/ISysLockScreenModule'
import { ISysModManagerModule } from '@/contracts/system-modules/mod-manager/ISysModManagerModule'
import { ISysSyncModule } from '@/contracts/system-modules/sync/ISysSyncModule'
import { ISysShareModule } from '@/contracts/system-modules/share/ISysShareModule'
import { ISysWinManagerModule } from '@/contracts/system-modules/win-manager/ISysWinManagerModule'
import { ISysUpdateModule } from '@/contracts/system-modules/update/ISysUpdateModule'
import { ISysGroupsModule } from '@/contracts/system-modules/groups/ISysGroupsModule'
import { EnumConsoleType } from '@/contracts/system-modules/console/enum/EnumConsoleType'
import { IEventBus } from '@/contracts/core/event/interface/IEventBus'
import { EventProviderModule } from '@/core/event/EventProvider'

class SystemV1 implements ISystem {
  private static instance: ISystem

  public auth: ISysAuthModule
  public console: ISysConsoleModule
  public lockScreen: ISysLockScreenModule
  public modManager: ISysModManagerModule
  public sync: ISysSyncModule
  public share: ISysShareModule
  public groups: ISysGroupsModule
  public winManager: ISysWinManagerModule
  public update: ISysUpdateModule
  private eventBus: IEventBus

  constructor() {
    this.eventBus = EventProviderModule()
    this.auth = SysAuthProviderModule()
    this.console = SysConsoleProviderModule()
    this.lockScreen = SysLockScreenProviderModule()
    this.modManager = SysModManagerProviderModule()
    this.sync = SysSyncProviderModule()
    this.share = SysShareProviderModule()
    this.groups = SysGroupsProviderModule()
    this.winManager = SysWinManagerProviderModule()
    this.update = SysUpdateProviderModule()
  }

  public static getInstance(): ISystem {
    if (!SystemV1.instance) {
      SystemV1.instance = new SystemV1()
    }
    return SystemV1.instance
  }

  start(): boolean {
    this.console.log('System starting...', EnumConsoleType.SUCCESS)

    try {
      this._initSystemModules()

      this.console.log('System ready!', EnumConsoleType.SUCCESS)
      return true
    } catch (e) {
      this.console.log(`System start failed: ${e}`, EnumConsoleType.ERROR)
      return false
    }
  }

  getViewPath(): string {
    return '/v1/view/index.vue'
  }

  events(): IEventBus {
    return this.eventBus
  }

  _initSystemModules(): void {
    this.console.init()
    this.update.init()
    this.auth.init()
    this.lockScreen.init()
    this.sync.init()
    this.share.init()
    this.groups.init()
    this.modManager.init()
    this.winManager.init()
  }
}

export default function () {
  return SystemV1.getInstance()
}
